import React, { useEffect, useState } from "react";
import "./auth.scss";
import { authImg, loginScreen } from "assets/images";

import LoginPage from "./login/Login";
import OTPComponent from "./otp/OTP";
import ForgotPassword from "./forgotPassword/ForgotPassword";
import OTPComponents from "./forgotPassword/OTP";
import ResetPassword from "./resetPassword/ResetPassword";

const Auth = () => {
  const [step, setSteps] = useState(1);
  // const authFlow=localStorage.setItem("authFlow",1)
  const [data, setData] = useState({});
  console.log(step, "step");
  console.log(data, "data+");
  return (
    <>
      <div className="auth_section">
        <div className="auth_content">
          <div className="image_section">
            <img src={authImg} alt="" />
          </div>
          <div className="content_right">
            {step === 1 ? (
              <LoginPage setSteps={setSteps} data={data} setData={setData} />
            ) : step === 2 ? (
              <OTPComponent setSteps={setSteps} data={data} setData={setData} />
            ) : step === 3 ? (
              <ForgotPassword
                setSteps={setSteps}
                data={data}
                setData={setData}
              />
            ) : step === 4 ? (
              <OTPComponents
                data={data}
                setSteps={setSteps}
                setData={setData}
              />
            ) : step === 5 ? (
              <ResetPassword
                data={data}
                setSteps={setSteps}
                setData={setData}
              />
            ) : null}
            {/* {step === 1 && <LoginPage forgotPassword={()=>setSteps(3)} otp={()=>setSteps(2)}/>}
              {step === 2 && <OTPComponent />}
              {step === 3 && <ForgotPassword backToLogin={()=>setSteps(1)} />} */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Auth;
